exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g-audio-volume{display:-webkit-box;display:-ms-flexbox;display:flex;color:#fff}.g-audio-volume-fd{text-align:left}.g-audio-volume-hd{text-align:right}.g-audio-volume-bd{width:100px;padding:0 10px}.g-audio-volume-bd .el-slider__runway{margin:5px 0;height:2px}.g-audio-volume-bd .el-slider__bar{height:2px}.g-audio-volume-bd .el-slider__button{width:10px;height:10px;border:none;margin-top:-4px}", ""]);

// exports
